<template>
  <div class="tags-container">
    <!-- tag盒子 -->
    <div class="tags-box" :class="{'tags-box--close':!website.isFirstPage}">
      <el-tabs v-model="active"
               type="card"
               :closable="tagLen!==1"
               @tab-click="openTag"
               @edit="menuTag">
        <el-tab-pane :key="item.value"
                     v-for="item in tagList"
                     :label="item.label"
                     :name="item.value">
        </el-tab-pane>
      </el-tabs>
      <el-dropdown class="tags-menu pull-right">
        <el-button type="primary" size="mini">
          更多
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="closeOthersTags">关闭其他</el-dropdown-item>
          <el-dropdown-item @click.native="closeAllTags">关闭全部</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import {resolveUrlPath} from '@/util/util'
  import {mapState, mapGetters} from 'vuex'

  export default {
    name: 'tags',
    data() {
      return {
        active: ''
      }
    },
    created() {
    },
    mounted() {
      this.setActive()
    },
    watch: {
      tag() {
        this.setActive()
      }
    },
    computed: {
      ...mapGetters(['tagWel', 'tagList', 'tag', 'website']),
      tagLen: function () {
        return this.tagList.length || 0
      }
    },
    methods: {
      //激活当前选项
      setActive() {
        this.active = this.tag.value;
      },
      menuTag(value, action) {
        if (action === 'remove') {
          let {tag, key} = this.findTag(value);
          this.$store.commit('DEL_TAG', tag)
          if (tag.value === this.tag.value) {
            tag = this.tagList[key] || this.tagList[key - 1]
            this.openTag(tag)
          }
        }
      },
      openTag(item) {
        let tag;
        if (item.name) {
          tag = this.findTag(item.name).tag;
        } else {
          tag = item;
        }
        this.$router.push({
          path: resolveUrlPath(tag.value, tag.label),
          query: tag.query
        })
      },
      closeOthersTags() {
        this.$store.commit('DEL_TAG_OTHER')
      },
      findTag(value) {
        let tag, key;
        this.tagList.map((item, index) => {
          if (item.value === value) {
            tag = item;
            key = index;
          }
        });
        return {tag: tag, key: key};
      },
      closeAllTags() {
        this.$store.commit('DEL_ALL_TAG')
        this.$router.push({
          path: resolveUrlPath(this.tagWel.value),
          query: this.tagWel.query
        })
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// tags.vue?69e20f85